var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getIsLoading)?_c('Loading'):_vm._e(),_c('header',[_c('p',[_vm._v(_vm._s(_vm.getTranslation.create_review))])]),(_vm.init || _vm.$route.name === 'Error')?_c('router-view',{staticClass:"components",attrs:{"user":_vm.getUser,"lang":_vm.getTranslation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }